import type { FaireProductEntity } from "../../entity_types/product";

export const p_4r5bzy2cqq: FaireProductEntity = {
  token: "p_4r5bzy2cqq",
  type: "product",
  name: "Tree Taper Candles | Green",
  brandToken: "b_nzmj9numer",
  brandName: "Sunshine Studios",
  imageUrl:
    "https://cdn.faire.com/fastly/d25b71146872a1131549dc0bb453e7e56dfcaeb722c0933326909d6b01e6a816.jpeg",
  galleryImageUrls: [],
  priceDollars: 9.99,
  description:
    "Light up your holiday celebrations with these green Tree Taper Candles! Shaped like festive trees, they bring a cheerful and playful vibe to your holiday décor. Perfect for adding a splash of green and a warm glow to your seasonal gatherings, these candles make every moment feel merry and bright.\n\n.       Set of 2\n.       Size | 10 x 0.5 inches\n.       Wax | Blend of Soy and Beeswax\n.       Disclaimer |  Images are digital renderings, physical product may vary in color from the        images. \n.       Imported",
  tags: [],
  msrpDollars: 19.99,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:16.217Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
